import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  reportModal: {
    isOpen: false,
    itemId: null,
    itemType: 'post',
    postAuthorId: null
  }
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openReportModal: (state, action) => {
      const { itemId, itemType, postAuthorId } = action.payload || {};
      state.reportModal = {
        isOpen: true,
        itemId: itemId || null,
        itemType: itemType || 'post',
        postAuthorId: postAuthorId || null
      };
    },
    closeReportModal: (state) => {
      state.reportModal = {
        isOpen: false,
        itemId: null,
        itemType: 'post',
        postAuthorId: null
      };
    }
  }
});

export const {
  openReportModal,
  closeReportModal
} = modalSlice.actions;

export default modalSlice.reducer;
